// extracted by mini-css-extract-plugin
export default {"userStat":"UserStat_userStat__RjJOY"};